exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.metric-card .col-lg-7 .dboard-card-panel-section[data-v-95bb5458]{padding-top:30px\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build/frontend/shipper/src/components/dashboard/IndentedNew.vue"],"names":[],"mappings":";AACA,mEAAmE,gBAAgB;CAClF","file":"IndentedNew.vue","sourcesContent":["\n.metric-card .col-lg-7 .dboard-card-panel-section[data-v-95bb5458]{padding-top:30px\n}"],"sourceRoot":""}]);

// exports
